import { useTranslation } from "react-i18next";
import { PMDialog } from "../../utils/PMDialog";

/**
 * User-facing dialog explaining how a summary number is calculated.
 */
export const CalculationGuideDialog = ({
  open,
  onClose,
  titleKey,
  bodyKey,
  bodyParams,
}) => {
  const { t } = useTranslation();

  if (!open || !titleKey) return null;

  return (
    <PMDialog
      open={open}
      onClose={onClose}
      title={titleKey}
      size="lg"
      closeOnOutsideClick
    >
      <div className="space-y-3 text-sm text-slate-700 whitespace-pre-line">
        <p>{t(bodyKey, bodyParams)}</p>
      </div>
    </PMDialog>
  );
};

export default CalculationGuideDialog;
